import React from 'react';
import PropTypes from 'prop-types';

import './DoubleSideLayout.style.scss';

const DoubleSideLayout = ({ rightContent, leftContent }) => (
  <div className="dna-double-side">
    {leftContent}
    {rightContent}
  </div>
);

DoubleSideLayout.propTypes = {
  rightContent: PropTypes.node,
  leftContent: PropTypes.node,
};

export default DoubleSideLayout;
